/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type ItemsPaginationWrapper_portfolioNode$ref = any;
type ItemsRefetchWrapper_portfolioNode$ref = any;
type Recommendations_trending$ref = any;
type RequestShippingQuoteModal_viewer$ref = any;
type Tiles_viewer$ref = any;
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type ItemsContainer_viewer$ref = any;
export type ItemsContainer_viewer = {
    readonly id: string;
    readonly user?: {
        readonly serviceId: string | null;
        readonly isVerifiedTrade: boolean | null;
        readonly profile: {
            readonly currency: Currency | null;
            readonly email: string | null;
        } | null;
    } | null;
    readonly itemsPortfolios?: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly isPublic: boolean | null;
                readonly serviceId: string | null;
                readonly totalPortfolioItems: {
                    readonly totalResults: number | null;
                } | null;
                readonly " $fragmentRefs": ItemsRefetchWrapper_portfolioNode$ref & ItemsPaginationWrapper_portfolioNode$ref;
            } | null;
        } | null> | null;
    } | null;
    readonly " $fragmentRefs": Recommendations_trending$ref & RequestShippingQuoteModal_viewer$ref & Tiles_viewer$ref;
    readonly " $refType": ItemsContainer_viewer$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any), v2 = ({
        "kind": "Literal",
        "name": "first",
        "value": 1
    } as any);
    return {
        "kind": "Fragment",
        "name": "ItemsContainer_viewer",
        "type": "Viewer",
        "metadata": null,
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "userId",
                "type": "String!"
            },
            {
                "kind": "RootArgument",
                "name": "hasUserId",
                "type": "Boolean"
            },
            {
                "kind": "RootArgument",
                "name": "portfolioTypes",
                "type": "[PortfolioTypes]"
            },
            {
                "kind": "RootArgument",
                "name": "userIds",
                "type": "[String]"
            },
            {
                "kind": "RootArgument",
                "name": "loadPortfolioData",
                "type": "Boolean"
            }
        ],
        "selections": [
            (v0 /*: any*/),
            {
                "kind": "FragmentSpread",
                "name": "Recommendations_trending",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "RequestShippingQuoteModal_viewer",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "Tiles_viewer",
                "args": null
            },
            {
                "kind": "Condition",
                "passingValue": true,
                "condition": "hasUserId",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "user",
                        "storageKey": null,
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "userId",
                                "variableName": "userId"
                            }
                        ],
                        "concreteType": "User",
                        "plural": false,
                        "selections": [
                            (v1 /*: any*/),
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "isVerifiedTrade",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "profile",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Profile",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "currency",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "email",
                                        "args": null,
                                        "storageKey": null
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "Condition",
                "passingValue": true,
                "condition": "loadPortfolioData",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": "itemsPortfolios",
                        "name": "portfolios",
                        "storageKey": null,
                        "args": [
                            (v2 /*: any*/),
                            {
                                "kind": "Variable",
                                "name": "portfolioTypes",
                                "variableName": "portfolioTypes"
                            },
                            {
                                "kind": "Variable",
                                "name": "userIds",
                                "variableName": "userIds"
                            }
                        ],
                        "concreteType": "PortfoliosConnection",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "edges",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "PortfoliosEdge",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "node",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "PortfolioV2",
                                        "plural": false,
                                        "selections": [
                                            (v0 /*: any*/),
                                            {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "isPublic",
                                                "args": null,
                                                "storageKey": null
                                            },
                                            (v1 /*: any*/),
                                            {
                                                "kind": "LinkedField",
                                                "alias": "totalPortfolioItems",
                                                "name": "items",
                                                "storageKey": "items(first:1)",
                                                "args": [
                                                    (v2 /*: any*/)
                                                ],
                                                "concreteType": "PortfolioItemsConnection",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "alias": null,
                                                        "name": "totalResults",
                                                        "args": null,
                                                        "storageKey": null
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "ItemsRefetchWrapper_portfolioNode",
                                                "args": null
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "ItemsPaginationWrapper_portfolioNode",
                                                "args": null
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = '2e5da55a7f48db4817c3a6fdac6e0c5f';
export default node;
